export default {
  hero: {
    eyebrow: "AllChinaBuy Spreadsheet",
    title: "Finde bessere Produkte mit dem AllChinaBuy Spreadsheet",
    subtitle:
      "Erkunde organisierte AllChinaBuy Spreadsheet-Ressourcen, Produktfunde, Verkäuferinformationen, QC-Guides, Versandtipps, Bewertungen und praktische Kaufreferenzen — alles an einem Ort.",
    previewTitle: "Spreadsheet-Vorschau",
    previewCols: {
      category: "Kategorie",
      product: "Produkt",
      seller: "Verkäufer",
      price: "Preis",
      qc: "QC",
      shipping: "Versand",
      updated: "Aktualisiert",
    },
    previewRows: {
      r1: ["Schuhe", "Low-top Sneaker", "Verifiziert", "$$", "Bestanden", "5–12 Tage", "Heute"],
      r2: ["Hoodies", "Oversize Hoodie", "Beliebt", "$$", "Bestanden", "5–12 Tage", "Heute"],
      r3: ["T-Shirts", "Boxy Tee", "Verifiziert", "$", "Bestanden", "4–10 Tage", "Heute"],
      r4: ["Taschen", "Alltagstasche", "Beliebt", "$$", "Ausstehend", "6–14 Tage", "Heute"],
    },
  },
  what: {
    title: "Was ist das AllChinaBuy Spreadsheet?",
    body1:
      "Das AllChinaBuy Spreadsheet ist eine bequeme Möglichkeit, Produktressourcen, Kategorien, Verkäuferinformationen und nützliche Kaufreferenzen zu organisieren und zu entdecken.",
    body2:
      "Statt verstreute Seiten zu durchsuchen, nutze unsere strukturierten Guides und Spreadsheet-Ressourcen, um Produkte zu vergleichen, QC-Informationen zu verstehen, Versandoptionen zu recherchieren und fundiertere Entscheidungen zu treffen.",
  },
  categories: {
    title: "Beliebte AllChinaBuy Spreadsheet-Kategorien",
    subtitle:
      "Durchsuche organisierte Produktkategorien und gehe zu den passenden Seiten unserer Hauptwebsite.",
    select: "Zu einer Kategorie springen",
    viewAll: "Alle Kategorien ansehen",
  },
  before: {
    title: "Alles, was du vor dem Kauf wissen solltest",
    cards: {
      review: {
        title: "AllChinaBuy Bewertung",
        text: "Verstehe die Plattform, den Ablauf, die Vorteile und mögliche Einschränkungen.",
      },
      shipping: {
        title: "AllChinaBuy Versandkosten",
        text: "Erfahre, was Versandkosten, Liefermethoden und Gesamtausgaben beeinflussen kann.",
      },
      warehouse: {
        title: "AllChinaBuy Lager",
        text: "Verstehe Lagerung, QC-Prüfung und lagerbezogene Überlegungen.",
      },
      coupon: {
        title: "AllChinaBuy Coupon",
        text: "Finde Informationen zu Coupons, Aktionen und wie Rabattangebote allgemein funktionieren.",
      },
      discount: {
        title: "AllChinaBuy Rabattcode",
        text: "Erfahre, wie Rabattcodes funktionieren können und was du vor der Nutzung prüfen solltest.",
      },
      legit: {
        title: "Ist AllChinaBuy seriös",
        text: "Verstehe wichtige Überlegungen zu Seriosität, Sicherheit und Verifizierung.",
      },
    },
  },
  compare: {
    title: "Vergleiche vor dem Kauf",
    subtitle: "Nutze diese Vergleichspunkte für fundiertere Entscheidungen.",
    headers: {
      topic: "Thema",
      check: "Was zu prüfen ist",
      considerations: "Wichtige Überlegungen",
      bestFor: "Am besten für",
    },
    rows: {
      products: {
        topic: "Produkte",
        check: "Fotos, Maße, Materialien",
        considerations: "Vergleiche mehrere Angebote, bevor du wählst",
        bestFor: "Das richtige Produkt finden",
      },
      sellers: {
        topic: "Verkäufer",
        check: "Bewertungen, Historie, Reaktion",
        considerations: "Bevorzuge Verkäufer mit klarer Historie",
        bestFor: "Risiko reduzieren",
      },
      shipping: {
        topic: "Versand",
        check: "Methode, Gewicht, Ziel",
        considerations: "Schwerere Artikel kosten meist mehr",
        bestFor: "Budget planen",
      },
      qc: {
        topic: "QC",
        check: "Prüffotos, Maße",
        considerations: "Fordere QC vor dem Versand an, wenn möglich",
        bestFor: "Probleme früh erkennen",
      },
      categories: {
        topic: "Kategorien",
        check: "Relevanter Produkttyp",
        considerations: "Beginne mit der richtigen Kategorie",
        bestFor: "Schnelleres Stöbern",
      },
      buying: {
        topic: "Kaufmethoden",
        check: "Checkout-Ablauf, Zahlung",
        considerations: "Verstehe den Ablauf, bevor du bestellst",
        bestFor: "Reibungsloserer Checkout",
      },
    },
  },
  how: {
    title: "So funktioniert das AllChinaBuy Spreadsheet",
    steps: {
      s1: { title: "Wähle eine Kategorie", text: "Beginne mit der Kategorie, die zu deinem Bedarf passt." },
      s2: { title: "Erkunde Spreadsheet-Ressourcen", text: "Sieh dir die organisierten Produkt- und Verkäuferreferenzen an." },
      s3: { title: "Vergleiche Produkt & Verkäufer", text: "Wäge Optionen Seite an Seite ab, bevor du entscheidest." },
      s4: { title: "Prüfe QC & Kauferwägungen", text: "Verstehe, was du vor der Bestellung prüfen solltest." },
      s5: { title: "Recherchiere Versand & Lager", text: "Schätze Kosten, Lieferzeit und Lagerung." },
      s6: { title: "Weiter zur Hauptwebsite", text: "Gehe zur Hauptwebsite, wenn du bereit bist zu kaufen." },
    },
  },
  qc: {
    title: "AllChinaBuy QC- & Sicherheitsguide",
    body: "Behalte diese praktischen Punkte vor der Bestellung im Hinterkopf.",
    items: {
      photos: { title: "QC-Fotos", text: "Prüfe Inspektionsfotos und fordere wenn möglich zusätzliche Aufnahmen an." },
      inspection: { title: "Produktprüfung", text: "Kontrolliere Maße, Etiketten und den Gesamtzustand." },
      seller: { title: "Verkäuferverifizierung", text: "Sieh dir Verkäuferhistorie und Feedback vor dem Kauf an." },
      descriptions: { title: "Produktbeschreibungen", text: "Lies Angebote sorgfältig, um Größe und Material zu bestätigen." },
      payment: { title: "Zahlungsbewusstsein", text: "Nutze ausschließlich den offiziellen Checkout-Ablauf." },
      shipping: { title: "Versandrisiken", text: "Verstehe Lieferzeiten und mögliche Verzögerungen." },
      refund: { title: "Rückerstattungen", text: "Kenne die Rückerstattungsrichtlinie, bevor du dich verpflichtest." },
      personal: { title: "Persönliche Daten", text: "Schütze deine Daten und vermeide unbestätigte Kontakte." },
      scam: { title: "Warnsignale für Betrug", text: "Sei vorsichtig bei Angeboten, die zu gut erscheinen." },
    },
    read: "Sicherheitsguide lesen",
  },
  guides: {
    title: "Neueste AllChinaBuy Guides & Bewertungen",
    subtitle: "Entdecke unsere originellen Guides mit praktischen und nützlichen Kaufinformationen.",
    card1: {
      category: "Spreadsheet-Guide",
      title: "Was ist das AllChinaBuy Spreadsheet? Kompletter 2026-Guide",
      summary: "Ein vollständiger Überblick über Funktionsweise, Inhalt und Nutzung des Spreadsheets.",
      date: "Aktualisiert 2026",
      cta: "Guide lesen",
    },
    card2: {
      category: "QC & Sicherheit",
      title: "AllChinaBuy QC- & Sicherheits-Checkliste",
      summary: "Praktische Punkte vor dem Kauf — von QC-Fotos bis zur Verkäuferprüfung.",
      date: "Aktualisiert 2026",
      cta: "Mehr erfahren",
    },
    card3: {
      category: "Versand",
      title: "AllChinaBuy Versand & Kosten",
      summary: "Was Versandkosten, Lieferzeit und Lagerlagerung beeinflusst.",
      date: "Aktualisiert 2026",
      cta: "Mehr erfahren",
    },
  },
  faq: {
    title: "Häufig gestellte Fragen",
    items: {
      q1: {
        q: "Was ist ein AllChinaBuy Spreadsheet?",
        a: "Es ist eine organisierte Ressource, die Produktfunde, Kategorien, Verkäufer und Kaufreferenzen bündelt, damit du Optionen vor der Bestellung leichter vergleichen kannst.",
      },
      q2: {
        q: "Wie funktioniert das Spreadsheet?",
        a: "Du beginnst mit einer Kategorie, erkundest die organisierten Ressourcen, vergleichst Produkte und Verkäufer, prüfst QC und Versand und gehst dann zur Hauptwebsite.",
      },
      q3: {
        q: "Ist AllChinaBuy seriös?",
        a: "AllChinaBuy ist eine Shopping-Agent-ähnliche Plattform, die viele Käufer nutzen. Führe deine eigene Prüfung durch, kontrolliere die Verkäuferhistorie und lies die Bedingungen vor der Bestellung.",
      },
      q4: {
        q: "Ist AllChinaBuy sicher?",
        a: "Nutze den offiziellen Checkout-Ablauf, schütze deine persönlichen Daten und sei vorsichtig bei Angeboten, die zu gut erscheinen.",
      },
      q5: {
        q: "Wie viel kostet der AllChinaBuy-Versand?",
        a: "Die Kosten hängen von Gewicht, Maßen, Methode und Ziel ab. Schwerere und größere Artikel kosten meist mehr, und schnellere Methoden sind oft teurer.",
      },
      q6: {
        q: "Gibt es AllChinaBuy-Coupons?",
        a: "Coupons und Aktionen variieren über die Zeit. Prüfe die Hauptwebsite auf aktuelle Angebote und lies die Bedingungen, bevor du einen Code nutzt.",
      },
      q7: {
        q: "Was ist das AllChinaBuy-Lager?",
        a: "Das Lager ist der Ort, an dem Artikel vor dem Versand gelagert und geprüft werden können. Lagerung und QC können Kosten und Zeitplan beeinflussen.",
      },
      q8: {
        q: "Wie prüfe ich QC?",
        a: "Fordere QC-Fotos an, prüfe Maße, Etiketten und Zustand und vergleiche sie mit der Beschreibung, bevor du den Versand freigibst.",
      },
      q9: {
        q: "Wie vergleiche ich Produkte?",
        a: "Nutze die Vergleichspunkte oben: Prüfe Fotos, Verkäufer, Versand, QC und Kategorien Seite an Seite für eine fundiertere Entscheidung.",
      },
    },
  },
  finalCta: {
    title: "Bereit, mehr zu entdecken?",
    body: "Finde organisierte Ressourcen, praktische Guides und nützliche Kaufinformationen vor deinem nächsten Einkauf.",
    button: "Spreadsheet erkunden",
    secondary: "Hauptwebsite besuchen",
  },
};